import React, { useRef, useState } from "react";

// components
import ColourButton from "./ColourButton";
import ColourPicker from "../ColourPicker";

//interfaces
import { bottomRow, IThemeColour, ThemeColours, topRow } from "../../../../interfaces/pickers/ThemeColourPicker";

//hooks
import { useClickAwayClose } from "../../../../hooks/useClickAwayClose";



const ThemeColourPicker = ({ colour, setColour }: IThemeColour) => {
    const dropdownWrapperRef = useRef<HTMLDivElement | null>(null);
    const [showDropdownColourPicker, setShowDropdownColourPicker]=useState<boolean>(false);
    const presetColours = [...topRow, ...bottomRow];
    const isPresetColour = presetColours.includes(colour as ThemeColours);

    useClickAwayClose(
        showDropdownColourPicker,
        dropdownWrapperRef as React.RefObject<HTMLElement>,
        () => {setShowDropdownColourPicker(false)}
    );
        
    return (
        <div className="theme-colour-container">
            <h3>Theme colour</h3>

            <div className="colour-grid">
                <div className="row">
                    {topRow.map((colourButton) => (
                        <ColourButton 
                            key={colourButton}
                            colour={colourButton} 
                            setColour={() => setColour(colourButton)} 
                            isSelected={colourButton === colour}                        
                        />
                    ))}
                </div>

                <div className="row">
                    {bottomRow.map((colourButton) => (
                        <ColourButton 
                            key={colourButton}
                            colour={colourButton} 
                            setColour={() => setColour(colourButton)} 
                            isSelected={colourButton === colour}                  
                        />
                    ))}
                    <div className="add-button-wrapper" ref={dropdownWrapperRef}>
                        <button
                            className={`colour-button add-button ${!isPresetColour ? "selected-add-button" : ""}`}
                            onClick={() => setShowDropdownColourPicker(!showDropdownColourPicker)}
                        >
                            +
                        </button>

                        {showDropdownColourPicker && (
                            <div className="colour-picker-container" >
                                <ColourPicker
                                    setHasError={() => {}}
                                    color={colour}
                                    setColor={setColour}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThemeColourPicker
